export const getters = {
  APPLICANTS: (state) => state.applicants,
  RECRUITERS: (state) => state.recruiters,
  PLANS: (state) => state.billing_plans,
  PLAN: (state) => state.billing_plan,
  CONTRACTS: (state) => state.contracts,
  INVOICES: (state) => state.invoices
}
